import React, { useCallback, useState } from 'react';
import PremiumFeatureModal from '../PremiumFeatureModal';
import ShareDialog from './ShareDialog';
import { ShareKind } from '../../api/sharingApi';

/**
 * The share entry point, for every place that has one: a function to open it
 * and the UI it opens.
 *
 * The teaser stands in front of inviting, which is what premium buys, not in
 * front of the dialog itself: someone whose premium has lapsed still has
 * people on their work, and taking that access back must not be the thing
 * they have to pay to do. The server draws the line in the same place, so a
 * 402 mid-dialog opens the teaser too.
 */
export const useShare = (kind: ShareKind, id: number | null | undefined, name: string) => {
  const [open, setOpen] = useState(false);
  const [paywall, setPaywall] = useState(false);

  const openShare = useCallback(() => setOpen(true), []);

  const shareUi = (
    <>
      {open && id != null && (
        <ShareDialog
          kind={kind}
          id={id}
          name={name}
          onClose={() => setOpen(false)}
          onUpgradeRequired={() => { setOpen(false); setPaywall(true); }}
        />
      )}
      {paywall && (
        <PremiumFeatureModal feature="collaboration" onClose={() => setPaywall(false)} />
      )}
    </>
  );

  return { openShare, shareUi };
};

export default useShare;
